import Vue from 'vue';

export default Vue.component('edit-progress-bar', {
  template: require('./template.html'),
  name: 'edit-progress-bar',
  props: ['droplet', 'show-edit-bubble'],
  data() {
    return {
      endText: '',
      progress: 0,
      total: 0,
      unit: '',
    };
  },
  created() {
    this.setInitialValues();
  },
  methods: {
    setInitialValues() {
      this.endText = this.droplet.endText || '';
      this.progress = this.droplet.progress || 0;
      this.total = this.droplet.total || 0;
      this.unit = this.droplet.unit || '';
    },
    setDropletVal(key, bounce) {
      const val = this._getInputVal(this[key]);
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        key,
        val,
      });
      if (bounce) {
        this._debounce(() => this.$emit('bounce-plugin'), 1000);
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/progress-bar/components/_edit-options/index.js